export interface FornecedorPedidoCompra {
  cPedido: string;
  cDataEmissao: string;
  cNomeComprador: string;
  cTransportadora: string;
  cTipoFrete: string;
  cDescCondPag: string;
  cCliRazaoSocial: string;
  cCliCNPJ: string;
  cCliEndereco: string;
  cCliBairro: string;
  cCliCodMun: string;
  cCliEstado: string;
  cCliInscrEst: string;
  cCliInscrMun: string;
  cCliTelefone: string;
  cCliFax: string;
  cForRazaoSocial: string;
  cForCNPJ: string;
  cForEndereco: string;
  cForBairro: string;
  cForCodMun: string;
  cForEstado: string;
  cForInscrEst: string;
  cForInscrMun: string;
  cForTelefone: string;
  cForFax: string;
  cObserv1: string;
  cObserv2: string;
  nBaseCalcICMS: string;
  nValorICMS: string;
  nCalcSubICMS: string;
  nValorSubICMS: string;
  nVlrTotalProd: string;
  nValorFrete: string;
  nValorSeguro: string;
  nDesconto: string;
  nOutrasDesp: string;
  nValorIPI: string;
  nVlrTotalPed: string;
  items: Array<FornecedorPedidoCompraItens>
  lServico: boolean;
};

export interface FornecedorPedidoCompraLista {
  items: Array<FornecedorPedidoCompra>;
};

export const defaultFornecedorPedidoCompra = (): FornecedorPedidoCompra => {
  return {
    cPedido: '',
    cDataEmissao: '',
    cNomeComprador: '',
    cTransportadora: '',
    cTipoFrete: '',
    cDescCondPag: '',
    cCliRazaoSocial: '',
    cCliCNPJ: '',
    cCliEndereco: '',
    cCliBairro: '',
    cCliCodMun: '',
    cCliEstado: '',
    cCliInscrEst: '',
    cCliInscrMun: '',
    cCliTelefone: '',
    cCliFax: '',
    cForRazaoSocial: '',
    cForCNPJ: '',
    cForEndereco: '',
    cForBairro: '',
    cForCodMun: '',
    cForEstado: '',
    cForInscrEst: '',
    cForInscrMun: '',
    cForTelefone: '',
    cForFax: '',
    cObserv1: '',
    cObserv2: '',
    nBaseCalcICMS: '',
    nValorICMS: '',
    nCalcSubICMS: '',
    nValorSubICMS: '',
    nVlrTotalProd: '',
    nValorFrete: '',
    nValorSeguro: '',
    nDesconto: '',
    nOutrasDesp: '',
    nValorIPI: '',
    nVlrTotalPed: '',
    items: [],
    lServico: false,
  };
};

export interface FornecedorPedidoCompraItens {
  cProduto: string;
  cDescProdServ: string;
  cNcm: string;
  nQuantidade: string;
  cUm: string;
  cDataEntrega: string;
  nValorUnit: string;
  nValorTotal: string;
  nIcm: string;
  nIpi: string;
  cDescTes: string;
};

export const defaultFornecedorPedidoCompraItens = (): FornecedorPedidoCompraItens => {
  return {
    cProduto: '',
    cDescProdServ: '',
    cNcm: '',
    nQuantidade: '',
    cUm: '',
    cDataEntrega: '',
    nValorUnit: '',
    nValorTotal: '',
    nIcm: '',
    nIpi: '',
    cDescTes: '',
  };
};

export interface DadosFornecedor {
  CCHAVE: string;
  CCODFOR: string;
  CLOJFOR: string;
  CIP: string;
};

export const defaultDadosFornecedor = (): DadosFornecedor => {
  return {
    CCHAVE: '',
    CCODFOR: '',
    CLOJFOR: '',
    CIP: '',
  };
};
